import React from "react";
import { Stack, Typography } from "@mui/material";
import Detail from "./detail";
import { useSelector } from "react-redux";
import moment from "moment";

function Details() {
  const { currentHd } = useSelector((state: any) => state.restaurant);

  if (!currentHd) return null;

  return (
    <Stack
      sx={{
        height: "100%",
        backgroundColor: "background.paper",
        px: 1,
        borderRadius: "10px",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          height: "42px",
          borderBottom: "1px dashed",
          borderColor: "divider",
        }}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{
              width: "35px",
              height: "35px",
              borderRadius: "50%",
              color: "common.white",
              backgroundColor: "primary.main",
            }}
          >
            {currentHd?.ten_ban}
          </Stack>
        </Stack>
        <Typography>{moment().format("HH:mm DD/MM/YYYY")}</Typography>
      </Stack>
      <Stack
        gap={1}
        sx={{ height: `calc(100% - 42px)`, overflow: "auto", px: 1, py: 1 }}
      >
        {currentHd?.details &&
          currentHd?.details?.length > 0 &&
          currentHd?.details.map((detail: any, index: number) => {
            return <Detail key={detail._id} stt={index + 1} data={detail} />;
          })}
      </Stack>
    </Stack>
  );
}

export default Details;
